// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__OrgSwitcher from "../OrgSidebar/OrgSwitcher.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarDocuments from "./SidebarDocuments.js";
import * as Buhta_cabinet__SidebarHrm from "./SidebarHrm.js";
import * as Buhta_cabinet__SidebarKassa from "./SidebarKassa.js";
import * as Buhta_cabinet__SidebarMain from "./SidebarMain.js";
import * as Buhta_cabinet__SidebarManage from "./SidebarManage.js";
import * as Buhta_cabinet__SidebarPayroll from "./SidebarPayroll.js";
import * as Buhta_cabinet__SidebarSettings from "./SidebarSettings.js";
import * as Buhta_cabinet__SidebarTaxes from "./SidebarTaxes.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import LogoSvg from "static/icons/logo.svg";

const headerItem = "cursor-pointer";

const Styles = {
  headerItem: headerItem
};

function make(org) {
  return function (sidebarItems) {
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
    const currentUrlStr = Buhta_cabinet__Route.toString(currentRoute);
    const match$1 = React.useState(function () {
          return false;
        });
    const setIsDropdownShown = match$1[1];
    const match$2 = React.useState(function () {
          if (typeof currentRoute === "number") {
            return "main";
          }
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                let tmp = currentRoute._1;
                if (typeof tmp === "number") {
                  return "main";
                }
                switch (tmp.TAG | 0) {
                  case /* Documents */1 :
                      return "documents";
                  case /* Kassa */2 :
                      return "kassa";
                  case /* Tax */4 :
                      return "taxes";
                  case /* Hrm */5 :
                      return "hrm";
                  case /* Payroll */6 :
                      return "payroll";
                  case /* Manage */7 :
                      return "manage";
                  case /* Settings */8 :
                      return "settings";
                  default:
                    return "main";
                }
            case /* Admin */7 :
                const match = currentRoute._0;
                if (typeof match === "number") {
                  return "main";
                }
                if (match.TAG !== /* Orgs */1) {
                  return "main";
                }
                const match$1 = match._0;
                if (typeof match$1 === "number") {
                  return "main";
                }
                let tmp$1 = match$1._1;
                if (typeof tmp$1 === "number") {
                  return "main";
                }
                switch (tmp$1.TAG | 0) {
                  case /* Kassa */2 :
                      return "kassa";
                  case /* Payroll */6 :
                      return "payroll";
                  case /* Manage */7 :
                      return "manage";
                  default:
                    return "main";
                }
            default:
              return "main";
          }
        });
    const setBar = match$2[1];
    const match$3 = tenant.ctx;
    const match$4 = tenant.ctx;
    const match$5 = tenant.ctx;
    let tmp;
    switch (match$2[0]) {
      case "documents" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarDocuments.make, {
                org: org,
                currentRoute: currentRoute,
                setBar: setBar
              });
          break;
      case "hrm" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarHrm.make, {
                setBar: setBar,
                currentRoute: currentRoute,
                org: org,
                setIsDropdownShown: setIsDropdownShown
              });
          break;
      case "kassa" :
          tmp = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__SidebarMain.make, {
                  org: org,
                  setIsDropdownShown: setIsDropdownShown,
                  setBar: setBar,
                  sidebarItems: sidebarItems
                }) : JsxRuntime.jsx(Buhta_cabinet__SidebarKassa.make, {
                  org: org,
                  currentRoute: currentRoute,
                  setBar: setBar,
                  setIsDropdownShown: setIsDropdownShown
                });
          break;
      case "manage" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarManage.make, {
                org: org,
                currentRoute: currentRoute,
                setBar: setBar,
                setIsDropdownShown: setIsDropdownShown
              });
          break;
      case "payroll" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarPayroll.make, {
                org: org,
                currentRoute: currentRoute,
                setBar: setBar,
                setIsDropdownShown: setIsDropdownShown
              });
          break;
      case "settings" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarSettings.make, {
                org: org,
                currentRoute: currentRoute,
                setBar: setBar,
                setIsDropdownShown: setIsDropdownShown
              });
          break;
      case "taxes" :
          tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarTaxes.make, {
                setBar: setBar,
                currentRoute: currentRoute,
                org: org,
                setIsDropdownShown: setIsDropdownShown
              });
          break;
      default:
        tmp = JsxRuntime.jsx(Buhta_cabinet__SidebarMain.make, {
              org: org,
              setIsDropdownShown: setIsDropdownShown,
              setBar: setBar,
              sidebarItems: sidebarItems
            });
    }
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: match$3 ? ({
                                          TAG: /* Admin */7,
                                          _0: /* Main */0
                                        }) : ({
                                          TAG: /* Org */6,
                                          _0: org.id,
                                          _1: /* Dashboard */0
                                        }),
                                    onLinkClicked: (function (param) {
                                        Curry._1(setBar, (function (param) {
                                                return "";
                                              }));
                                      }),
                                    children: JsxRuntime.jsx(LogoSvg, {
                                          alt: "logo"
                                        })
                                  }),
                              className: headerItem
                            }),
                        className: "flex justify-between px-6 pt-0 items-center"
                      }),
                  match$4 ? null : JsxRuntime.jsx(Buhta_cabinet__OrgSwitcher.make, {
                          org: org,
                          setBar: setBar
                        }),
                  match$5 ? JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                          route: {
                            TAG: /* Admin */7,
                            _0: {
                              TAG: /* Orgs */1,
                              _0: /* List */0
                            }
                          },
                          className: "px-6 mt-8 flex items-center",
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5 h-5",
                                  src: StaticAsset.src("/static/icons/back-arrow.svg")
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                  className: "ml-4 text-white",
                                  children: org.name
                                })
                          ]
                        }) : null,
                  tmp,
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                      route: {
                                        TAG: /* Admin */7,
                                        _0: /* Main */0
                                      },
                                      className: "p-2 hover:bg-gray-pale block",
                                      onLinkClicked: (function (param) {
                                          Curry._1(setIsDropdownShown, (function (param) {
                                                  return false;
                                                }));
                                          Curry._1(setBar, (function (param) {
                                                  return "main";
                                                }));
                                        }),
                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: "Админка"
                                          })
                                    }),
                                JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                      route: {
                                        TAG: /* Profile */5,
                                        _0: /* General */0
                                      },
                                      className: "p-2 hover:bg-gray-pale block",
                                      onLinkClicked: (function (param) {
                                          Curry._1(setIsDropdownShown, (function (param) {
                                                  return false;
                                                }));
                                        }),
                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: "Настройки профиля"
                                          }),
                                      urlParams: {
                                        hd: [
                                          "return_to",
                                          currentUrlStr
                                        ],
                                        tl: /* [] */0
                                      }
                                    }),
                                JsxRuntime.jsx("hr", {
                                      className: "my-1"
                                    }),
                                JsxRuntime.jsxs("button", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                              className: "text-alert",
                                              children: "Выйти из аккаунта"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "w-5 h-5",
                                              src: StaticAsset.src("/static/icons/logout-red-20.svg")
                                            })
                                      ],
                                      className: "flex p-2 hover:bg-gray-pale justify-between w-full",
                                      onClick: (function (param) {
                                          window.location.href = "/logout";
                                        })
                                    })
                              ],
                              className: "bg-white w-60 p-2 shadow-kkms rounded absolute bottom-16"
                            }),
                        className: Cn.$plus("absolute inset-0 pl-4", Cn.on("hidden", !match$1[0])),
                        onClick: (function (param) {
                            Curry._1(setIsDropdownShown, (function (param) {
                                    return false;
                                  }));
                          })
                      })
                ],
                className: "flex flex-col bg-black py-6 border-r border-white/8 duration-500 transition-width ease-out w-61 overflow-y-auto shrink-0 z-50"
              });
  };
}

function Sidebar(Props) {
  return make(Props.org)(Props.sidebarItems);
}

const make$1 = Sidebar;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_cabinet__Link Not a pure module */
